var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"role-add-user"},[(_vm.added)?_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","size":"mini","loading":_vm.loading},on:{"click":_vm.doDel}},[_vm._v("删除")]):_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus","size":"mini","loading":_vm.loading},on:{"click":_vm.doAdd}},[_vm._v("添加")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }